import React from 'react';
import { Box } from '@wix/design-system';
import { ShowcaseSingleCard } from '../ShowcaseSingleCard';
export const ShowcaseCards = {
    Card: ShowcaseSingleCard,
    List: ({ children, className, dataHook, ...boxOverrides }) => (React.createElement(Box, { className: className, dataHook: dataHook, ...boxOverrides }, children)),
};
//# sourceMappingURL=ShowcaseCards.js.map